import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Profiles
export const getProfiles = (role) => api.get('/profiles', { params: role ? { role } : {} });
export const createProfile = (data) => api.post('/profiles', data);
export const updateProfile = (id, data) => api.put(`/profiles/${id}`, data);
export const deleteProfile = (id) => api.delete(`/profiles/${id}`);

// Simulation
export const startSimulation = (profileId) => api.post('/simulation/start', { profile_id: profileId });
export const sendMessage = (sessionId, message) => api.post('/simulation/message', { session_id: sessionId, message });
export const endSimulation = (sessionId) => api.post('/simulation/end', { session_id: sessionId });

// Audio
export const textToSpeech = (text, voice) => api.post('/audio/tts', { text, voice: voice || 'onyx' });
export const speechToText = (formData) => api.post('/audio/stt', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// Sessions
export const getSessions = () => api.get('/sessions');
export const getSession = (id) => api.get(`/sessions/${id}`);

// User
export const getUserProfile = () => api.get('/users/profile');
export const updateUserProfile = (data) => api.put('/users/profile', data);
export const getUserStats = () => api.get('/users/stats');

// Leaderboard
export const getLeaderboard = () => api.get('/leaderboard');

// Notifications
export const getNotifications = () => api.get('/notifications');
export const markNotificationsRead = () => api.put('/notifications/read');

// Admin
export const getAdminUsers = () => api.get('/admin/users');
export const getAdminAnalytics = () => api.get('/admin/analytics');
export const getAdminSessions = () => api.get('/admin/sessions');
export const sendAdminNotification = (data) => api.post('/admin/notifications', data);

export default api;
